import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=12cd1f6a&scoped=true&"
import script from "./Advanced.vue?vue&type=script&lang=js&"
export * from "./Advanced.vue?vue&type=script&lang=js&"
import style0 from "./Advanced.vue?vue&type=style&index=0&id=12cd1f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd1f6a",
  null
  
)

export default component.exports